import { FC } from 'react';
import { Modal } from '../..';
import TransactionLabelField from '../../transaction/TransactionLabelField';
import { MarketPlaceBreederPaymentTransaction } from '../../../types/interfaces/marketPlace.interfaces';
import { centsToDollars } from '../../../services/account.service';
import {
  BREEDER_PAYMENTS_CONSTANTS,
  BUTTON_CONSTANTS,
  MARKETPLACE_CONSTANTS,
  PAYMENT_CONSTANTS,
  RSG_CONSTANTS,
  TABLE_HEADER_CONSTANTS,
} from '../../../constants/common';
import './payoutPaymentDetailsModal.scss';

export type PayoutPaymentDetailsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  payoutDetail: MarketPlaceBreederPaymentTransaction | null;
  width?: number;
};

const formatDate = (date?: string) => (date ? new Date(date).toLocaleDateString('en-US') : '-');
const formatAmount = (amountCents?: number) => `$${centsToDollars(amountCents ?? 0)}`;

const PayoutPaymentDetailsModal: FC<PayoutPaymentDetailsModalProps> = ({ isOpen, onClose, payoutDetail, width = 600 }) => (
  <Modal isOpen={isOpen} onClose={onClose} width={width} ignoreBackdrop>
    <div className="payout-payment-details-modal">
      <div className="payout-payment-details card inventory-action">
        <h2>{BREEDER_PAYMENTS_CONSTANTS.PAYMENT_DETAILS}</h2>
        <TransactionLabelField
          label={`${TABLE_HEADER_CONSTANTS.BILL_DATE}:`}
          value={<label>{formatDate(payoutDetail?.billedDate)}</label>}
        />
        <TransactionLabelField
          label={`${TABLE_HEADER_CONSTANTS.ORDERS}:`}
          value={<label>{payoutDetail?.numberOfOrders ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
        />
        <TransactionLabelField
          label={`${PAYMENT_CONSTANTS.TOTAL_AMOUNT}:`}
          value={<label>{formatAmount(payoutDetail?.totalAmountCents)}</label>}
        />
        <TransactionLabelField
          label={`${RSG_CONSTANTS.RSG_COMMISSION}:`}
          value={<label>{formatAmount(payoutDetail?.rsgCommissionCents)}</label>}
        />
        <TransactionLabelField
          label={`${BREEDER_PAYMENTS_CONSTANTS.PAID_AMOUNT}:`}
          value={<label>{formatAmount(payoutDetail?.paidAmountCents)}</label>}
        />
        <TransactionLabelField
          label={`${TABLE_HEADER_CONSTANTS.PAYMENT_METHOD}:`}
          value={<label>{payoutDetail?.paymentMethod ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
        />
        <TransactionLabelField
          label={`${TABLE_HEADER_CONSTANTS.REFERENCE_ID}:`}
          value={<label>{payoutDetail?.transactionReferenceId ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
        />
        <TransactionLabelField
          label={`${TABLE_HEADER_CONSTANTS.PAYMENT_STATUS}:`}
          value={<label>{payoutDetail?.paymentStatus ?? MARKETPLACE_CONSTANTS.EMPTY_VALUE}</label>}
        />
        <TransactionLabelField
          label={`${TABLE_HEADER_CONSTANTS.BILLING_CYCLE_START}:`}
          value={<label>{formatDate(payoutDetail?.billingCycleStartDate)}</label>}
        />
        <TransactionLabelField
          label={`${TABLE_HEADER_CONSTANTS.BILLING_CYCLE_END}:`}
          value={<label>{formatDate(payoutDetail?.billingCycleEndDate)}</label>}
        />
      </div>
      <div className="flex-right">
        <button className="button medium green close-button" onClick={onClose}>
          {BUTTON_CONSTANTS.CLOSE}
        </button>
      </div>
    </div>
  </Modal>
);

export default PayoutPaymentDetailsModal;
